import type {Cancelable, EventEmitterType} from './types';

type Handler = (...args: any[]) => void;

export class EventEmitter implements EventEmitterType {
  private listeners = new Map<string, Set<Handler>>();
  private destroyed = false;

  on(eventName: string, handler: Handler): Cancelable {
    if (this.destroyed) return {cancel: () => {}};

    let handlers = this.listeners.get(eventName);
    if (!handlers) {
      handlers = new Set();
      this.listeners.set(eventName, handlers);
    }
    handlers.add(handler);

    return {
      cancel: () => {
        handlers!.delete(handler);
      }
    };
  }

  once(eventName: string, handler: Handler): Cancelable {
    const wrapper = (...args: any[]) => {
      this.off(eventName, wrapper);
      handler(...args);
    };
    return this.on(eventName, wrapper);
  }

  trigger(eventName: string, ...args: any[]): void {
    if (this.destroyed) return;
    const handlers = this.listeners.get(eventName);
    if (!handlers) return;
    for (const handler of handlers) {
      try {
        handler(...args);
      } catch (e) {
        console.error(e);
      }
    }
  }

  off(eventName: string, handler: Handler): void {
    const handlers = this.listeners.get(eventName);
    if (handlers) {
      handlers.delete(handler);
    }
  }

  destroy(): void {
    this.destroyed = true;
    this.listeners.clear();
  }
}
